import { render } from "./OfficialServer.vue?vue&type=template&id=61e8fbc8&scoped=true"
import script from "./OfficialServer.vue?vue&type=script&lang=js"
export * from "./OfficialServer.vue?vue&type=script&lang=js"

import "./OfficialServer.vue?vue&type=style&index=0&id=61e8fbc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61e8fbc8"]])

export default __exports__